import { type SalaryRangeData } from 'modules/planning/types/headcount'

const CENTS_DIVISOR = 100

interface WithValueSalaryRange {
  valueSalaryRange?: {
    min?: string | null
    max?: string | null
    currency: string
  } | null
}

export const extractSalaryRange = <
  T extends { attributes?: ReadonlyArray<WithValueSalaryRange> | null },
>(
  source: T | null | undefined
): SalaryRangeData | undefined => {
  const range = source?.attributes?.find((a) => a.valueSalaryRange)?.valueSalaryRange
  if (!range) return undefined

  return {
    min: range.min ? Number(range.min) / CENTS_DIVISOR : null,
    max: range.max ? Number(range.max) / CENTS_DIVISOR : null,
    currency: range.currency,
  }
}
